  <div *ngIf="reportType == 'InDetail'">
    <div class="container-fluid px-4" id="print-section">
      <table class="table table-bordered table-sm mt-4 w-100">
        <thead class="text-center align-middle">
          <tr class="custom-header">
            <th colspan="3" class="br-top br-bottom br-right">Vivek Saptahik</th>
            <th colspan="3" class="br-top br-bottom br-right">Advt. Payment Receipt Ledger</th>
            <th colspan="3" class="br-top br-bottom">
              Date From: {{ startDate | date: 'dd-MM-yyyy' }} To: {{ endDate | date: 'dd-MM-yyyy' }}
            </th>
             <th colspan="3" class="br-top br-bottom br-right">InDetail</th>
          </tr>
          <!-- <tr class="custom-header">
            <th colspan="4" class="br-top br-bottom br-right">Date-wise</th>
            <th colspan="8" class="br-top br-bottom">In Details</th>
          </tr> -->
          <tr class="custom-header">
            <th>Receipt No</th>
            <th>Receipt <br> Date</th>
            <th>Entry Date</th>
            <th>Advertiser Name</th>
            <th>Rep. Name</th>
            <th>Office Rep. Name</th>
            <th>Issue Name</th>
            <th>Issue <br>Date</th>
            <th>Invoice No</th>
            <th>Invoice<br> Date</th>
            <th class="text-end">Net <br> Amount</th>
            <th class="text-end">Received<br>Amount</th>
            
          </tr>
        </thead>
  
        <tbody>
          <ng-container *ngFor="let data of advtPaymentRegiInDetailsFormBeans">
            <tr>
                <td>{{ data.rcpt_no }}</td>
              <td>{{ data.rcpt_date }}</td>
              <td>{{ data.entry_date }}</td>
              <td>{{ data.advt_name | slice:0:35 }}</td>
              <td>{{ data.rep_name }}</td>
              <td>{{ data.off_rep_name }}</td>
              <td>{{ data.DS_ISSUENAME | slice:0:25 }}</td>
              <td>{{ data.DS_ISSUEDATE | slice:0:10 }}</td>
              <td>{{ data.advt_invoice_no }}</td>
              <td>{{ data.advt_invoice_date }}</td>
              <td class="text-end" style="text-align: end;">{{ data.net_amt }}</td>
              <td class="text-end" style="text-align: end;">{{ data.rcv_amt }}</td>
            </tr>
          </ng-container>
        </tbody>
  
        <!-- <tfoot> -->
          <tr>
            <td colspan="10"  style="text-align: center;  background-color: #f1f1f1 !important;font-weight:bold"class="text-end">Total:</td>
            <td class="text-end" style="text-align: end;  background-color: #f1f1f1 !important;font-weight:bold">{{(PaymentadvtOffInDTotal_netamt * 1).toFixed(2)}}</td>
            <td class="text-end" style="text-align: end; background-color: #f1f1f1 !important;font-weight:bold">{{(PaymentadvtOffInDTotal * 1).toFixed(2) }}</td>
          </tr>
        <!-- </tfoot> -->
      </table>
    </div>
  
    <div class="noPrint d-flex justify-content-end gap-3 px-4 mb-4">
      <button class="btn btn-primary" (click)="exportExcel('Contract_InDetails_Report')">Export</button>
      <button class="btn btn-primary" (click)="printPage4()">Print</button>
      <button class="btn btn-secondary" mat-dialog-close>Close</button>
    </div>
  </div>